// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__dTf11"};